
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruitment-solutions/industry-insights",
      function () {
        return require("private-next-pages/recruitment-solutions/industry-insights/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruitment-solutions/industry-insights"])
      });
    }
  